<!-- <app-breadcrumb [title]="'Serious ailment Details'"></app-breadcrumb> -->


<!-- <h6 class="fw-bold">{{ title }}</h6> -->

<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton">
  <div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="6">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <div class="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom">
      <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
      <a [routerLink]="['/employee/profile/other-details']" class="btn btn-outline-primary">Cancel</a>
    </div>
  <form [formGroup]="diseaseInfoForm" (ngSubmit)="save()">
    <input type="hidden" formControlName="id">
    <input type="hidden" formControlName="financialYearId">
    <input type="hidden" formControlName="profileId">
    <input type="hidden" formControlName="diseaseCertId">
    <input type="hidden" formControlName="isActive">

    <div class="border rounded p-3 mb-3">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label class="form-label" for="diseaseId">Disease</label>
            <select MyInput formControlName="diseaseId" class="form-select form-select-sm">
              <option value="" selected>--SELECT--</option>
              <option *ngFor="let item of diseases" value="{{ item.value }}">{{ item.text }}
              </option>
            </select>
            <my-error controlName="diseaseId" errorKey="required">Disease is required.
            </my-error>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label class="form-label" for="relationId">Relation</label>
            <select MyInput formControlName="relationId" class="form-select form-select-sm">
              <option value="" selected>--SELECT--</option>
              <option *ngFor="let item of relations" value="{{ item.value }}">{{ item.text }}
              </option>
            </select>
            <my-error controlName="relationId" errorKey="required">Relation is required.
            </my-error>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label class="form-label" for="customFile">Valid Certificate</label>
        </div>
        <div class="col-md-4">
            <input class="form-control" type="file" #inputDoc
              (change)="handleFileInput($event.target.files);OnSubmit(inputDoc)">
          <my-error controlName="diseaseCertId" errorKey="required">Valid Certificate is required.</my-error>
        </div>
        <div class="col-md-4 align-items-center" *ngIf="diseaseInfoForm.get('diseaseCertId').value">
          <span class="mr-2">
            <i-bs name="check2-circle" width="1em" height="1em"></i-bs>
          </span>
        </div>
        <div class="col-md-4" *ngIf="diseaseInfo?.diseaseCert">
          <a target="_blank" [href]="diseaseInfo.diseaseCert?.mediaUrl" class="btn btn-success">
            <span class="mr-2">
              <i-bs name="check2-circle" width="1em" height="1em"></i-bs>
            </span>
            Preview Uploaded Document
          </a>
        </div>

      </div>
      <div id="progress-avatar" class="progress progress-xs" [class.fade]="!isProgress">
        <div [style.width]="barWidth + '%'" class="progress-bar progress-bar-striped progress-bar-animated bg-success"
          role="progressbar" aria-valuemin="0" aria-valuemax="100">
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label class="form-label" for="detectionDate">Disease Detection/Surgery Date</label>
            <div class="input-group">
              <span class="input-group-text">
                <i-bs name="calendar3" width="1em" height="1em"></i-bs>
              </span>
              <input MyInput formControlName="detectionDate" class="form-control form-control-sm datepicker"
                ngbDatepicker #detectionDate="ngbDatepicker" (click)="detectionDate.toggle()" />
            </div>
            <my-error controlName="detectionDate" errorKey="required">Disease Detection/Surgery Date is required.
            </my-error>
            <my-error controlName="detectionDate" errorKey="pattern">Date pattern invalid.</my-error>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-3">
            <label class="form-label" for="certIssueDate">Cert. Issue Date</label>
            <div class="input-group">
              <span class="input-group-text"><i-bs name="calendar3" width="1em" height="1em"></i-bs></span>
              <input MyInput formControlName="certIssueDate" class="form-control form-control-sm datepicker"
                ngbDatepicker #certIssueDate="ngbDatepicker" (click)="certIssueDate.toggle()" />
            </div>
            <my-error controlName="certIssueDate" errorKey="required">Cert. Issue Date is required.
            </my-error>
            <my-error controlName="certIssueDate" errorKey="pattern">Date pattern invalid.</my-error>
          </div>
        </div>
        <div class="col-md-9">
          <div class="row">
            <label class="col-sm-6 col-form-label" for="isValidCert1">Cert. issued/ countersigned by CHO/CMS/CS?</label>
            <div class="col-sm-6">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" formControlName="isValidCert" name="isValidCert"
                  id="isValidCert1" [value]="true">
                <label class="form-check-label" for="isValidCert1">YES</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" formControlName="isValidCert" name="isValidCert"
                  id="isValidCert2" [value]="false">
                <label class="form-check-label" for="isValidCert2">NO</label>
              </div>
              <my-error controlName="isValidCert" errorKey="required">Cert. issued/ countersigned by CHO/CMS/CS? is required.
              </my-error>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <button class="btn btn-primary rounded-0 ml-auto mr-5" [disabled]="!diseaseInfoForm.valid || loading"
        type="submit">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
        Submit
      </button>
      <button *ngIf="id" type="button" (click)="delete()" class="btn btn-danger rounded-0">Clear</button>
    </div>
  </form>
</div>
</div>
</div>
